var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "industrial") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "industrial"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,53a3,3,0,1,0,3,3A3,3,0,0,0,8,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,8,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,53a3,3,0,1,0,3,3A3,3,0,0,0,16,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,16,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,53a3,3,0,1,0,3,3A3,3,0,0,0,24,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,24,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,53a3,3,0,1,0,3,3A3,3,0,0,0,40,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,40,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,53a3,3,0,1,0,3,3A3,3,0,0,0,48,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,48,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,53a3,3,0,1,0,3,3A3,3,0,0,0,32,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,32,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,53a3,3,0,1,0,3,3A3,3,0,0,0,56,53Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,56,57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 47,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,49a3,3,0,0,0-3-3H51.816A3,3,0,0,0,49,44H15a3,3,0,0,0-2.816,2H10V26.312L15.394,31.7a1,1,0,0,0,.7.292L18.585,32l2.708,2.708,1.414-1.414L20,30.586V28a1,1,0,0,0-.3-.713l-7.767-7.634A4.847,4.847,0,0,0,12,19a5,5,0,1,0-8,3.974v23.21a2.987,2.987,0,0,0-.216,5.553A6,6,0,0,0,8,62H56a6,6,0,0,0,4.216-10.263A3,3,0,0,0,62,49ZM15,46H49a1,1,0,0,1,1,1v3H14V47A1,1,0,0,1,15,46Zm3-17.581V30l-1.485,0-6.808-6.8h0a5.006,5.006,0,0,0,1.478-1.471ZM7,16a3,3,0,1,1-3,3A3,3,0,0,1,7,16Zm0,8a5,5,0,0,0,1-.1H8V46H6V23.9A5,5,0,0,0,7,24ZM5,50a1,1,0,0,1,0-2h7v2H5ZM56,60H8a4,4,0,0,1,0-8H56a4,4,0,0,1,0,8ZM52,50V48h7a1,1,0,0,1,0,2H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,33.026V9.444A3.987,3.987,0,0,0,58,2H6a4,4,0,0,0,0,8H54V29.688L48.606,24.3a1,1,0,0,0-.7-.292L45.415,24l-2.708-2.708-1.414,1.414L44,25.414V28a1,1,0,0,0,.3.713l7.767,7.634A4.847,4.847,0,0,0,52,37a5,5,0,1,0,8-3.974ZM4,6A2,2,0,0,1,6,4H58a2,2,0,0,1,0,4H6A2,2,0,0,1,4,6Zm54,4V32.1a5,5,0,0,0-2,0h0V10ZM46,27.581V26l1.485,0,6.808,6.8h0a5.006,5.006,0,0,0-1.478,1.471ZM57,40a3,3,0,1,1,3-3A3,3,0,0,1,57,40Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 36,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,42a3,3,0,0,0,3-3V15a3,3,0,0,0-3-3H27a3,3,0,0,0-3,3V39a3,3,0,0,0,3,3ZM26,39V15a1,1,0,0,1,1-1H37a1,1,0,0,1,1,1V39a1,1,0,0,1-1,1H27A1,1,0,0,1,26,39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.379,
    y: 15.5,
    width: 4.243,
    height: 2,
    transform: "translate(1.074 35.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 19,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 35,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.379,
    y: 38.5,
    width: 4.243,
    height: 2,
    transform: "translate(-21.926 26.065) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 36,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 2,
    height: 14
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.091d0dc3964d9d12ce5e12e64dc8a47c.svg";
export { ForwardRef as ReactComponent };